import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiSingleOrders = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10H20C20.55 10 21.0208 10.1958 21.4125 10.5875C21.8042 10.9792 22 11.45 22 12V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H12ZM12 20H20V12H12V20ZM6 18V8C6 7.45 6.19583 6.97917 6.5875 6.5875C6.97917 6.19583 7.45 6 8 6H18V8H8V18H6ZM2 14V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H14V4H4V14H2Z" />
  </SvgWrapper>
);
